import {DrilldownPath} from '../_models/drilldown';

export class TagBreadcrumbs {
    breadcrumbs: Array<TagBreadcrumb> = [];

    constructor(breadcrumbs?: Array<TagBreadcrumb>) {
        if (breadcrumbs) this.breadcrumbs = breadcrumbs;
    }
}

interface TagBreadcrumb {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/app/header/tagBreadcrumbs.ts